export default {
    en: {
        Salli: 'US English',
        Matthew: 'US English',
        Kimberly: 'US English',
        Kendra: 'US English',
        Justin: 'US English',
        Joey: 'US English',
        Joanna: 'US English',
        Ivy: 'US English',
        Geraint: 'Welsh English',
        Raveena: 'Indian English',
        Aditi: 'Indian English',
        Emma: 'British English',
        Brian: 'British English',
        Amy: 'British English',
        Russell: 'Australian English',
        Nicole: 'Australian English',
    },
    tr: {
        Filiz: 'Turkish',
    },
    sv: {
        Astrid: 'Swedish',
    },
    ru: {
        Tatyana: 'Russian',
        Maxim: 'Russian',
    },
    ro: {
        Carmen: 'Romanian',
    },
    pt: {
        Ines: 'Portuguese, Portugal',
        Cristiano: 'Portuguese, Portugal',
        Vitoria: 'Portuguese, Brasil',
        Ricardo: 'Portuguese, Brasil',
        Camila: 'Portuguese, Brasil',
    },
    pl: {
        Maja: 'Polish',
        Jan: 'Polish',
        Jacek: 'Polish',
        Ewa: 'Polish',
    },
    nl: {
        Ruben: 'Dutch',
        Lotte: 'Dutch',
    },
    nb: {
        Liv: 'Norwegian',
    },
    ko: {
        Seoyeon: 'Korean',
    },
    ja: {
        Takumi: 'Japanese',
        Mizuki: 'Japanese',
    },
    it: {
        Bianca: 'Italian',
        Giorgio: 'Italian',
        Carla: 'Italian',
    },
    is: {
        Karl: 'Icelandic',
        Dora: 'Icelandic',
    },
    fr: {
        Mathieu: 'French',
        Lea: 'French',
        Celine: 'French',
        Chantal: 'Canadian French',
    },
    es: {
        Penelope: 'Español, Latinoamérica',
        Miguel: 'Español, Latinoamérica',
        Lupe: 'Español, Latinoamérica',
        Mia: 'Español, Latinoamérica',
        Lucia: 'Español, España',
        Enrique: 'Español, España',
        Conchita: 'Español, España',
    },
    de: {
        Vicki: 'German',
        Marlene: 'German',
        Hans: 'German',
    },
    da: {
        Naja: 'Danish',
        Mads: 'Danish',
    },
    cy: {
        Gwyneth: 'Welsh',
    },
    zh: {
        Zhiyu: 'Chinese Mandarin',
    },
    ar: {
        Zeina: 'Arabic',
    },
};
